/* eslint-disable import/prefer-default-export */
import { getStaticCDN } from '@design-system/utils/utils';
import { TRegionKey } from '@source/interface';
import { ENV_URL } from '@source/constants/common';
import { CUSTOMER_REVIEW } from '@source/components/CustomerReview/content';
import { ICustomerReviewContent } from '@source/components/CustomerReview';
import { NEXT_PUBLIC_WEB_CR } from '@source/constants/env';

// Todo_CCPO: add some configs here
export const INSPECTION_POINT = (region: TRegionKey, lang: string, isMobile?: boolean) => {
  const getImgSrcByLang = (imageName: string, ext = 'jpg') => {
    // Pattern desktop: {fileName} + "-" | "" + {lang}.jpeg
    // Pattern mobile: {fileName} + "-mb-" + {lang}.jpg
    let langCode = '';
    switch (lang) {
      case 'zh-SG':
      case 'zh-MY':
        langCode = 'zh';
        break;
      default:
        langCode = lang;
        break;
    }

    const dashSymbol = langCode !== '' ? '-' : '';

    // TODO_CCPO: We might need to refactor this func once the translation is finalized
    // I think we're trying to show EN in all countries except TW.
    // langCode = ['en', 'zh-TW', 'ja', 'ms-SG', 'ms', 'zh-MY'].includes(lang) ? lang : 'en';

    // The TW zh-TW images are updated so need to have a new file name to prevent image caching. Temp use `v{modifiedDate}` first.
    // const modifiedDate = lang === 'zh-TW' ? '-23122022' : '';
    const countryPostFix = lang === 'ms' && region === 'sg' ? `-${region}` : '';

    // return getStaticCDN(
    //   `/tr:bg-fff/assets/shared/ccpo-landing/inspection-points-v2/${imageName}${dashSymbol}${langCode}${modifiedDate}.jpeg`,
    // );
    return getStaticCDN(
      ['my', 'jp', 'hk'].includes(region)
        ? `/tr:bg-fff/assets/${region}/ccpo-landing/inspection-points/${imageName}${dashSymbol}${langCode}${countryPostFix}.${ext}`
        : `/tr:bg-fff/assets/shared/ccpo-landing/inspection-points-v3/${imageName}${dashSymbol}${langCode}${countryPostFix}.${ext}`,
    );
  };

  let desc = 'ccpo.inspectionPoint.description';
  let title = 'ccpo.inspectionPoint.title';
  let images = [
    {
      key: 'skeleton-part-one',
      isOnlyDesktop: true,
      width: 888,
      height: 615,
      url: getImgSrcByLang('skeleton-v3-3/skeleton-part-one', 'webp'),
      alt: 'Inspection Point',
    },
    {
      key: 'skeleton-part-one-mb',
      isOnlyMobile: true,
      width: 311,
      height: 261,
      url: getImgSrcByLang('skeleton-v3-3/skeleton-part-one-mb', 'webp'),
      alt: 'Inspection Point',
    },
    {
      key: 'skeleton-part-two',
      isOnlyDesktop: true,
      width: 804,
      height: 467,
      url: getImgSrcByLang('skeleton-v3-3/skeleton-part-two', 'webp'),
      alt: 'Inspection Point',
    },
    {
      key: 'skeleton-part-two-mb',
      isOnlyMobile: true,
      width: 308,
      height: 204,
      url: getImgSrcByLang('skeleton-v3-3/skeleton-part-two-mb', 'webp'),
      alt: 'Inspection Point',
    },
    {
      key: 'side-by-side',
      isOnlyDesktop: true,
      width: 1114,
      height: 834,
      isBothEdge: true,
      url: getImgSrcByLang('skeleton-v3-3/side-by-side', 'webp'),
      alt: 'Inspection Point One',
    },
    {
      key: 'side-by-right-mb',
      isOnlyMobile: true,
      width: 614,
      height: 570,
      url: getImgSrcByLang('skeleton-v3-3/side-by-right-mb', 'webp'),
      alt: 'Inspection Point One',
    },
    {
      key: 'side-by-left-mb',
      isOnlyMobile: true,
      width: 615,
      height: 653,
      url: getImgSrcByLang('skeleton-v3-3/side-by-left-mb', 'webp'),
      alt: 'Inspection Point One',
    },
    {
      key: 'overview',
      isOnlyDesktop: true,
      width: 940,
      height: 882,
      isMiddle: true,
      url: getImgSrcByLang('skeleton-v3-3/overview', 'webp'),
      alt: 'Inspection Point One',
    },
    {
      key: 'overview-mb',
      isOnlyMobile: true,
      width: 633,
      height: 520,
      isMiddle: true,
      url: getImgSrcByLang('skeleton-v3-3/overview-mb', 'webp'),
      alt: 'Inspection Point One',
    },
    {
      key: 'front-internal-part',
      isOnlyDesktop: true,
      width: 1013,
      height: 527,
      isBothEdge: true,
      url: getImgSrcByLang('skeleton-v3-3/front-internal-part', 'webp'),
      alt: 'Inspection Point One',
    },
    {
      key: 'front-internal-part-mb',
      isOnlyMobile: true,
      width: 608,
      height: 340,
      isBothEdge: true,
      url: getImgSrcByLang('skeleton-v3-3/front-internal-part-mb', 'webp'),
      alt: 'Inspection Point One',
    },
  ];

  switch (region) {
    case 'my':
      desc = isMobile ? 'ccpo.inspectionPoint.descriptionMobileMY' : 'ccpo.inspectionPoint.descriptionMY';
      title = 'ccpo.inspectionPoint.titleMY';
      images = [
        {
          key: 'inspection-part-1',
          isOnlyDesktop: true,
          width: lang === 'ms' ? 826 : 784,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-1.1', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-2',
          isOnlyDesktop: true,
          width: 784,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-2', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-3',
          isOnlyDesktop: true,
          width: 791,
          height: 493,
          url: getImgSrcByLang('v2/inspection-part-3', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-1-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-1-mb', 'webp'),
          alt: 'Inspection Point One',
        },
        {
          key: 'inspection-part-2-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-2-mb', 'webp'),
          alt: 'Inspection Point One',
        },
        {
          key: 'inspection-part-3-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-3-mb', 'webp'),
          alt: 'Inspection Point One',
        },
      ];
      break;
    case 'hk':
      desc = isMobile ? 'ccpo.inspectionPoint.descriptionMobileMY' : 'ccpo.inspectionPoint.descriptionMY';
      title = 'ccpo.inspectionPoint.titleMY';
      images = [
        {
          key: 'inspection-part-1',
          isOnlyDesktop: true,
          width: 784,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-1.1', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-2',
          isOnlyDesktop: true,
          width: 784,
          height: 492,
          url: getImgSrcByLang('v2/inspection-part-2', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-3',
          isOnlyDesktop: true,
          width: 791,
          height: 493,
          url: getImgSrcByLang('v2/inspection-part-3', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-1-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-1-mb', 'svg'),
          alt: 'Inspection Point One',
        },
        {
          key: 'inspection-part-2-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-2-mb', 'svg'),
          alt: 'Inspection Point One',
        },
        {
          key: 'inspection-part-3-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('v2/inspection-part-3-mb', 'svg'),
          alt: 'Inspection Point One',
        },
      ];
      break;
    case 'jp':
      desc = isMobile ? 'ccpo.inspectionPoint.descriptionMobileJP' : 'ccpo.inspectionPoint.descriptionJP';
      title = 'ccpo.inspectionPoint.titleJP';
      images = [
        {
          key: 'inspection-part-1',
          isOnlyDesktop: true,
          width: lang === 'ms' ? 826 : 784,
          height: 465,
          url: getImgSrcByLang('inspection-part-1', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-2',
          isOnlyDesktop: true,
          width: 784,
          height: 492,
          url: getImgSrcByLang('inspection-part-2', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-3',
          isOnlyDesktop: true,
          width: 784,
          height: 493,
          url: getImgSrcByLang('inspection-part-3', 'webp'),
          alt: 'Inspection Point',
        },
        {
          key: 'inspection-part-1-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('inspection-part-1-mb', 'webp'),
          alt: 'Inspection Point One',
        },
        {
          key: 'inspection-part-2-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('inspection-part-2-mb', 'webp'),
          alt: 'Inspection Point One',
        },
        {
          key: 'inspection-part-3-mb',
          isOnlyMobile: true,
          width: 324,
          height: 465,
          url: getImgSrcByLang('inspection-part-3-mb-updated', 'webp'),
          alt: 'Inspection Point One',
        },
      ];
      break;
    default:
      desc = 'ccpo.inspectionPoint.description';
  }

  return {
    title,
    description: desc,
    link: {
      text: 'ccpo.inspectionPoint.seeWhatInspected',
      // url: region === 'my' ? '/mytukar-certified-inspectionpoints' : '/carro-certified-inspectionpoints',
      url: '/carro-certified-inspectionpoints',
      gtmEvent: {
        event: 'clicked_ccpo_see_whats_inspected',
        page_name: 'ccpo_landing',
      },
      textMobile: 'ccpo.inspectionPoint.seeWhatInspectedMobile',
    },
    images,
  };
};

export const BANNER_CERTIFIED = (region: TRegionKey) => {
  switch (region) {
    case 'jp':
      return [
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/inspection-160.svg'),
          content: 'ccpo.banner.certified.jp.cert1',
        },
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/15-day-guarantee.svg'),
          content: 'ccpo.banner.certified.jp.cert2',
        },
        {
          img: getStaticCDN('/assets/my/icons/mytukar-certified-v2/warranty.svg'),
          content: 'ccpo.banner.certified.jp.cert3',
        },
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/30-day-comprehensive-warranty.svg'),
          content: 'ccpo.banner.certified.jp.cert4',
        },
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/damage.svg'),
          content: 'ccpo.banner.certified.jp.cert5',
        },
      ];

    default:
      return [
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/inspection-160.svg'),
          content: 'ccpo.banner.certified.cert1',
        },
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/guarantee.svg'),
          content: 'ccpo.banner.certified.cert2',
        },
        {
          img: getStaticCDN('/assets/my/icons/mytukar-certified-v2/warranty.svg'),
          content: 'ccpo.banner.certified.cert3',
        },
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/mileage.svg'),
          content: 'ccpo.banner.certified.cert4',
        },
        {
          img: getStaticCDN('/assets/shared/icons/carro-certified-v2/damage.svg'),
          content: 'ccpo.banner.certified.cert5',
        },
      ];
  }
};

export const BANNER_IMGS = {
  1920: getStaticCDN('/assets/shared/ccpo-landing/banners/banner-1920.webp'),
  1280: getStaticCDN('/assets/shared/ccpo-landing/banners/banner-1280.webp'),
  992: getStaticCDN('/assets/shared/ccpo-landing/banners/banner-992.webp'),
  768: getStaticCDN('/assets/shared/ccpo-landing/banners/banner-768.webp'),
  576: getStaticCDN('/assets/shared/ccpo-landing/banners/banner-576.webp'),
  375: getStaticCDN('/assets/shared/ccpo-landing/banners/banner-375-v2.webp'),
};

export const CCPO_FEATURES = (country: string) => [
  {
    key: 'fiveDay',
    title: country === 'hk' ? `ccpo.features.fiveDay.titleHK` : `ccpo.features.fiveDay.title`,
    description: country === 'hk' ? `ccpo.features.fiveDay.descHK` : `ccpo.features.fiveDay.desc`,
    image: getStaticCDN('/assets/shared/ccpo-landing/ccpo-guarantee-v2.webp'),
    modal: {
      modalTitle: `ccpo.features.fiveDay.${country}.modalTitle`,
      modalBody: `ccpo.features.fiveDay.${country}.modalBody`,
    },
    link: {
      text: `ccpo.features.learnMore`,
    },
  },
  {
    key: 'twelveMonths',
    title: `ccpo.features.twelveMonths.title`,
    description: `ccpo.features.twelveMonths.desc`,
    image: getStaticCDN('/assets/shared/ccpo-landing/ccpo-warranty-v2.webp'),
    modal: {
      modalTitle: `ccpo.features.twelveMonths.${country}.modalTitle`,
      modalBody: `ccpo.features.twelveMonths.${country}.modalBody`,
    },
    link: {
      text: `ccpo.features.termAndCondi`,
    },
  },
  {
    key: 'noMileage',
    title: `ccpo.features.noMileage.title`,
    description: `ccpo.features.noMileage.desc`,
    image: getStaticCDN('/assets/shared/ccpo-landing/ccpo-mileage-v2.webp'),
  },
  {
    key: 'noMajor',
    title: `ccpo.features.noMajor.title`,
    description: `ccpo.features.noMajor.desc`,
    image: getStaticCDN('/assets/shared/ccpo-landing/ccpo-damage-v2.webp'),
  },
];

export const CCPO_FEATURES_V2 = (country: string) => {
  switch (country) {
    case 'jp':
      return [
        {
          key: 'fiveDay',
          title: `ccpo.features.fiveDay.titleJP`,
          titleMobile: `ccpo.features.fiveDay.titleJPMobile`,
          description: `ccpo.features.fiveDay.descJP`,
          descriptionMobile: `ccpo.features.fiveDay.descJP`,
          image: getStaticCDN('/assets/jp/ccpo-landing/guarantee/ccpo-15-money-back-warranty.webp'),
          modal: {
            modalTitle: `ccpo.features.fiveDay.jp.modalTitle`,
            modalTitleMobile: `ccpo.features.fiveDay.jp.modalTitleMobile`,
            modalBody: `ccpo.features.fiveDay.jp.modalBody`,
          },
          link: {
            text: `ccpo.features.learnMore`,
          },
        },
        {
          key: 'twelveMonths',
          title: `ccpo.features.twelveMonths.titleJP`,
          titleMobile: `ccpo.features.twelveMonths.titleJPMobile`,
          description: `ccpo.features.twelveMonths.descJP`,
          descriptionMobile: `ccpo.features.twelveMonths.descJP`,
          image: getStaticCDN('/assets/jp/ccpo-landing/guarantee/ccpo-12-warranty-engine-gearbox.webp'),
          modal: {
            modalTitle: `ccpo.features.twelveMonths.jp.modalTitle`,
            modalTitleMobile: `ccpo.features.twelveMonths.jp.modalTitleMobile`,
            modalBody: `ccpo.features.twelveMonths.jp.modalBody`,
          },
          link: {
            text: `ccpo.features.termAndCondi`,
          },
        },
        {
          key: 'noMileage',
          title: `ccpo.features.noMileage.titleJP`,
          titleMobile: `ccpo.features.noMileage.titleJPMobile`,
          description: `ccpo.features.noMileage.descJP`,
          descriptionMobile: `ccpo.features.noMileage.descJP`,
          image: getStaticCDN('/assets/jp/ccpo-landing/guarantee/ccpo-30-comprehensive-warranty.webp'),
          modal: {
            modalTitle: `ccpo.features.noMileage.jp.modalTitle`,
            modalTitleMobile: `ccpo.features.noMileage.jp.modalTitleMobile`,
            modalBody: `ccpo.features.noMileage.jp.modalBody`,
          },
          link: {
            text: `ccpo.features.termAndCondi`,
          },
        },
        {
          key: 'noMajor',
          title: `ccpo.features.noMajor.titleJP`,
          titleMobile: `ccpo.features.noMajor.titleJPMobile`,
          description: `ccpo.features.noMajor.descJP`,
          descriptionMobile: `ccpo.features.noMajor.descJP`,
          image: getStaticCDN('/assets/jp/ccpo-landing/guarantee/ccpo-no-mileage-tampering-accidents.webp'),
        },
      ];

    case 'hk':
      return [
        {
          key: 'fiveDay',
          title: `ccpo.features.fiveDay.titleHK`,
          titleMobile: `ccpo.features.fiveDay.titleHK`,
          description: `ccpo.features.fiveDay.descHK`,
          descriptionMobile: `ccpo.features.fiveDay.descHKMobile`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-5-day-11122024.webp'),
          modal: {
            modalTitle: `ccpo.features.fiveDay.hk.modalTitle`,
            modalTitleMobile: `ccpo.features.fiveDay.hk.modalTitle`,
            modalBody: `ccpo.features.fiveDay.hk.modalBody`,
          },
          link: {
            text: `ccpo.features.learnMore`,
          },
        },
        {
          key: 'twelveMonths',
          title: `ccpo.features.twelveMonths.titleHK`,
          titleMobile: `ccpo.features.twelveMonths.titleHK`,
          description: `ccpo.features.twelveMonths.descHK`,
          descriptionMobile: `ccpo.features.twelveMonths.descHKMobile`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-12-month-11122024.webp'),
          modal: {
            modalTitle: `ccpo.features.twelveMonths.hk.modalTitle`,
            modalTitleMobile: `ccpo.features.twelveMonths.hk.modalTitle`,
            modalBody: `ccpo.features.twelveMonths.hk.modalBody`,
          },
          link: {
            text: `ccpo.features.termAndCondi`,
          },
        },
        {
          key: 'noMileage',
          title: `ccpo.features.noMileage.titleHK`,
          titleMobile: `ccpo.features.noMileage.titleHK`,
          description: `ccpo.features.noMileage.descHK`,
          descriptionMobile: `ccpo.features.noMileage.descHKMobile`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-no-mileage-11122024.webp'),
        },
        {
          key: 'noMajor',
          title: `ccpo.features.noMajor.titleHK`,
          titleMobile: `ccpo.features.noMajor.titleHK`,
          description: `ccpo.features.noMajor.descHK`,
          descriptionMobile: `ccpo.features.noMajor.descHKMobile`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-no-major-accidents-11122024.webp'),
        },
      ];

    default:
      return [
        {
          key: 'fiveDay',
          title: `ccpo.features.fiveDay.titleMY`,
          titleMobile: `ccpo.features.fiveDay.titleMYMobile`,
          description: `ccpo.features.fiveDay.descMY`,
          descriptionMobile: `ccpo.features.fiveDay.descMY`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-5-day-11122024.webp'),
          modal: {
            modalTitle: `ccpo.features.fiveDay.my.modalTitle`,
            modalTitleMobile: `ccpo.features.fiveDay.my.modalTitleMobile`,
            modalBody: `ccpo.features.fiveDay.my.modalBody`,
          },
          link: {
            text: `ccpo.features.learnMore`,
          },
        },
        {
          key: 'twelveMonths',
          title: `ccpo.features.twelveMonths.titleMY`,
          titleMobile: `ccpo.features.twelveMonths.titleMYMobile`,
          description: `ccpo.features.twelveMonths.descMY`,
          descriptionMobile: `ccpo.features.twelveMonths.descMY`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-12-month-11122024.webp'),
          modal: {
            modalTitle: `ccpo.features.twelveMonths.my.modalTitle`,
            modalTitleMobile: `ccpo.features.twelveMonths.my.modalTitleMobile`,
            modalBody: `ccpo.features.twelveMonths.my.modalBody`,
          },
          link: {
            text: `ccpo.features.termAndCondi`,
          },
        },
        {
          key: 'noMileage',
          title: `ccpo.features.noMileage.titleMY`,
          titleMobile: `ccpo.features.noMileage.titleMYMobile`,
          description: `ccpo.features.noMileage.descMY`,
          descriptionMobile: `ccpo.features.noMileage.descMY`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-no-mileage-11122024.webp'),
        },
        {
          key: 'noMajor',
          title: `ccpo.features.noMajor.titleMY`,
          titleMobile: `ccpo.features.noMajor.titleMYMobile`,
          description: `ccpo.features.noMajor.descMY`,
          descriptionMobile: `ccpo.features.noMajor.descMY`,
          image: getStaticCDN('/assets/my/ccpo-landing/guarantee/ccpo-no-major-accidents-11122024.webp'),
        },
      ];
  }
};

export const HIGHLIGHTS_CONTENT: Array<{ key: string; title: string; highlight: string; endText?: string }> = [
  {
    key: 'first-automotive',
    title: 'ccpo.highlights.content1.title',
    highlight: 'ccpo.highlights.content1.highlight',
    endText: 'ccpo.highlights.content1.endText',
  },
  {
    key: 'linkedin',
    title: 'ccpo.highlights.content2.title',
    highlight: 'ccpo.highlights.content2.highlight',
    endText: 'ccpo.highlights.content2.endText',
  },
  {
    key: 'first-sing',
    title: 'ccpo.highlights.content3.title',
    highlight: 'ccpo.highlights.content3.highlight',
  },
  {
    key: 'first-asia',
    title: 'ccpo.highlights.content4.title',
    highlight: 'ccpo.highlights.content4.highlight',
    endText: 'ccpo.highlights.content4.endText',
  },
  {
    key: 'first-asia-hk',
    title: 'ccpo.highlights.content4.titleHK',
    highlight: 'ccpo.highlights.content4.highlight',
  },
];

export const FEATURED_IN = {
  desktop: [
    {
      key: 'cnbc',
      width: 205,
      height: 50,
      alt: 'CNBC',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/cnbc-logo-v4.webp'),
    },
    {
      key: 'businesstimes',
      width: 214,
      height: 20,
      alt: 'Business Times',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/businesstimes-logo.webp'),
    },
    {
      key: 'channelasia',
      width: 268,
      height: 41,
      alt: 'Channel Asia',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/channelasia-logo-v3.webp'),
    },
    {
      key: 'straitstimes',
      width: 270,
      height: 23,
      alt: 'Strait Times',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/straitstimes-logo.webp'),
    },
    {
      key: 'today',
      width: 121,
      height: 38,
      alt: 'Today',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/today-logo-v2.webp'),
    },
    {
      key: 'reuters',
      width: 215,
      height: 38,
      alt: 'Reuters',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/reuters-logo.webp'),
    },
  ],
  mobile: [
    {
      key: 'cnbc',
      width: 66,
      height: 24,
      alt: 'CNBC',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/cnbc-logo-v4.webp'),
    },
    {
      key: 'businesstimes',
      width: 69,
      height: 10,
      alt: 'Business Times',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/businesstimes-logo.webp'),
    },
    {
      key: 'channelasia',
      width: 86,
      height: 13,
      alt: 'Channel Asia',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/channelasia-logo-v2.webp'),
    },
    {
      key: 'straitstimes',
      width: 87,
      height: 7,
      alt: 'Strait Times',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/straitstimes-logo.webp'),
    },
    {
      key: 'today',
      width: 39,
      height: 13,
      alt: 'Today',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/today-logo.webp'),
    },
    {
      key: 'reuters',
      width: 69,
      height: 19,
      alt: 'Reuters',
      url: getStaticCDN('/assets/shared/ccpo-landing/logo/reuters-logo.webp?tr=w-69'),
    },
  ],
};

export const getReviewCCPO = (): { [key: string]: ICustomerReviewContent } => {
  const link: Record<TRegionKey, string> = {
    sg: `${ENV_URL.sg}/blog/category/carro-news`,
    my: `${NEXT_PUBLIC_WEB_CR}/my/blog/category/carro-news`,
    id: `${ENV_URL.id}/blog/category/berita/`,
    th: `${ENV_URL.th}/blog/category/carro-news`,
    jp: '',
    hk: `${NEXT_PUBLIC_WEB_CR}/hk/blog`,
  };
  const getFooter = (country: TRegionKey) => ({
    preText: `ccpo:ccpo.customerReview.footerDesc.${country}.preText`,
    anchor: {
      text: `ccpo:ccpo.customerReview.footerDesc.${country}.anchorText`,
      link: link[country],
    },
    postText: `ccpo:ccpo.customerReview.footerDesc.${country}.postText`,
    postTextMobile: `ccpo:ccpo.customerReview.footerDesc.${country}.postTextMobile`,
  });

  return {
    sg: {
      header: {
        title: 'ccpo:ccpo.customerReview.title.sg',
        description: 'ccpo:ccpo.customerReview.description',
      },
      customerReviews: CUSTOMER_REVIEW.sg,
      footer: getFooter('sg'),
    },
    id: {
      header: {
        title: 'ccpo:ccpo.customerReview.title.id',
        description: 'ccpo:ccpo.customerReview.description',
      },
      customerReviews: CUSTOMER_REVIEW.id,
      footer: getFooter('id'),
    },
    th: {
      header: {
        title: 'ccpo:ccpo.customerReview.title.th',
        description: 'ccpo:ccpo.customerReview.description',
      },
      customerReviews: CUSTOMER_REVIEW.th,
      footer: getFooter('th'),
    },
    my: {
      header: {
        title: 'ccpo:ccpo.customerReview.title.my',
        description: 'ccpo:ccpo.customerReview.description',
      },
      customerReviews: CUSTOMER_REVIEW.my,
      footer: getFooter('my'),
    },
    jp: {
      header: {
        title: 'ccpo:ccpo.customerReview.title.jp',
        description: 'ccpo:ccpo.customerReview.description',
      },
      customerReviews: CUSTOMER_REVIEW.jp,
      footer: getFooter('sg'),
    },
    hk: {
      header: {
        title: 'ccpo:ccpo.customerReview.title.hk',
        description: 'ccpo:ccpo.customerReview.description',
      },
      customerReviews: CUSTOMER_REVIEW.hk,
      footer: getFooter('hk'),
    },
  };
};
